var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"service"},[_c('div',{staticClass:"service-tile"},[_vm._v(_vm._s(_vm.$t('checkout.selectOrderType')))]),_c('span',{staticClass:"service-content"},[_vm._v(_vm._s(_vm.$t('checkout.dineIn')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }